import { Routes, RouterModule } from '@angular/router';
/* Modules -> System -> Views */
import { LocalConfigService } from '@hio/config';

const APP_ROUTES: Routes = [
  {
    path: ':mid', 
    loadChildren: () => import('@insight/factory').then(mod => mod.FACTORY_ROUTES), 
    canActivate: [LocalConfigService], data: { animation: 'fade' },
  }
];

export const routing = RouterModule.forRoot(APP_ROUTES, { useHash: true, paramsInheritanceStrategy: 'emptyOnly' });
